import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Session from '../../utils/session.service';
import BusinessRestServices from '../../services/business-rest.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'meditation-add-on',
	templateUrl: './meditation-add-on.component.html',
	imports: [ CommonModule, TranslatePipe, ItemNotificationComponent, FormsModule, RouterLink ]
})
export default class MeditationAddOnView implements OnInit {
	private session: Session = inject(Session);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	};
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		if (this.vm.user.parentBusinessUser && this.vm.user.parentBusinessUser.businessName) {
			this.vm.origin = this.vm.user.origin;
			
			var lang: any = this.vm.user.deviceLanguage || 'en_GB';
			if (lang == 'en_GB' || lang == 'et_EE' || lang == 'ru_RU' || lang == 'fi_FI') {
				this.vm.appLogoLang = lang.split("_")[0];
			} else {
				this.vm.appLogoLang = 'en';
			}
			
			this.vm.accountGuideVisible = false;
			
			this.vm.accountGuideStep2 = this.angularFilterHelperService.translate('Meditation.No_Partner_Account_Step_2')
				.replace('%s', this.vm.user.email);
			this.vm.addOnActiveText = this.angularFilterHelperService.translate('Meditation.Add_On_Active')
				.replace('%s', this.vm.user.email);
			this.vm.addOnActivated = false;
			
			this.businessRestServices.getSynctuitionStatus({}, (result) => {
				if (result.status == 'EMPLOYER_HAS_NO_ADD_ON') {
					this.vm.notActivatedByEmployer = true;
					this.vm.addOnNotActive = false;
					this.vm.showAppDownloadLinks = false;
					this.vm.activateButtonVisible = false;
				} else if (result.status == 'ADD_ON_NOT_ACTIVE') {
					this.vm.notActivatedByEmployer = false;
					this.vm.addOnNotActive = this.angularFilterHelperService.translate('Meditation.Add_On_Not_Activated')
						.replace('%s', this.vm.user.email);
					this.vm.showAppDownloadLinks = false;
					this.vm.activateButtonVisible = true;
				} else if (result.status == 'EXISTS') {
					this.vm.notActivatedByEmployer = false;
					this.vm.addOnNotActive = false;
					this.vm.addOnActivated = true;
					this.vm.showAppDownloadLinks = true;
					this.vm.activateButtonVisible = false;
				} else {
					this.vm.notActivatedByEmployer = false;
					this.vm.addOnNotActive = this.angularFilterHelperService.translate('Errors.Technical_Error');
					this.vm.showAppDownloadLinks = false;
					this.vm.activateButtonVisible = false;
				}
			});
			
			this.vm.activateSynctuition = this.activateSynctuition;
			
			this.vm.androidLink = 'https://play.google.com/store/apps/details?id=com.synctuition.synctuition';
			this.vm.iosLink = 'https://apps.apple.com/app/id1166940722?platform=iphone';
		} else {
			this.angularRoutingHelperService.setPathAndKeepQueryParams('/corporate/customers/limitation');
		}
	}
	
	activateSynctuition() {
		this.vm.activateButtonVisible = false;
		this.vm.accountGuideVisible = false;
		this.businessRestServices.activateSynctuition({}, (result) => {
			if (result.status == 'ACTIVATED') {
				this.vm.activateButtonVisible = false;
				this.vm.notActivatedByEmployer = false;
				this.vm.addOnActivated = true;
				this.vm.addOnNotActive = false;
				this.vm.showAppDownloadLinks = true;
			} else if (result.status == 'NO_USER') {
				this.vm.activateButtonVisible = false;
				this.vm.notActivatedByEmployer = false;
				this.vm.addOnNotActive = this.angularFilterHelperService.translate('Meditation.No_Partner_Account_Info')
					.replace('%s', this.vm.user.email);
				this.vm.showAppDownloadLinks = true;
				this.vm.accountGuideVisible = true;
			} else {
				this.vm.activateButtonVisible = false;
				this.vm.notActivatedByEmployer = false;
				this.vm.addOnNotActive = this.angularFilterHelperService.translate('Errors.Technical_Error');
				this.vm.showAppDownloadLinks = false;
			}
		});
	}
	
}